module.exports = __webpack_public_path__ + "KZ.png?65fa38e06b5d23349e87db63363bfbb2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/KZ.png
// module id = 373
// module chunks = 0